export function hourAndMinutes(date) {
  let hours = Math.floor(date / 3600)
  let minutes = Math.floor((date % 3600) / 60)
  return `${hours > 0? `${hours} h.`:''} ${hours > 0 && minutes > 0? 'y' :''} ${minutes > 0? `${minutes} min.`:''}`
}

export  function limitText(text, limit) {
  if (!text) return ''
  const palabras = text.split(' ')
  if (palabras.length > limit) {
    return palabras.slice(0, limit).join(' ') + '...'
  } else {
    return text
  }
}

export function DateToISOString(date) {
  if (!date) return ''
  const hours = new Date(date).getTimezoneOffset()
  const diference = (hours / 60) * -1
  return new Date(date).toISOString().replace('Z', `+0${diference}:00`)
}

export function mixArrays(array1, array2) {

  const mixArray = array1.concat(array2)

  let currentIndex = mixArray.length, temporaryValue, randomIndex

  while (currentIndex !== 0) {

    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    temporaryValue = mixArray[currentIndex]
    mixArray[currentIndex] = mixArray[randomIndex]
    mixArray[randomIndex] = temporaryValue
  }

  return mixArray
}

export function toLocaleNumber(number) {
  return new Intl.NumberFormat('de').format(number)
}

export function formatDateBlog(date) {
  const formatedDate = new Date(date)
  .toLocaleDateString('es-ES', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
  return formatedDate
}
export function shortDate(input) {
  if (input === '' || input === undefined || input === null) {
    return '-'
  }
  const options = {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit'
  }
  return new Intl.DateTimeFormat('es-ES', options).format(new Date(input))
}